<style>
@import '../../custom/css/aprovadas.css';
</style>

<template>
  <div class="aprovadas" id="inicio">
    <div class="row m-0">
      <div class="col-12" v-if="cotacoes.length > 0">
        <h1 class="title font-weight-bold text-uppercase">
          Aguardando o lojista conferir todos os itens
        </h1>
        <hr class="linha-amarela" />
      </div>
      <div class="col-12" v-else>
        <h1 class="title font-weight-bold text-uppercase">
          Sem Pedidos aguardando conferição de itens
        </h1>
        <hr class="linha-amarela" />
      </div>
      <div
        class="col-lg-4 col-md-6 col-sm-12 col-12"
        v-for="(cotacao, index) in cotacoes"
        :key="index"
      >
        <div class="card-cotacao">
          <div class="cc-header d-flex">
            <div class="cc-sub-title m-r-25">
              <img
                class="imagem-archive-cotacao"
                src="@/assets/img/icons/file-archive.png"
                alt="Ícone para representar o Orçamento"
              />
            </div>
            <div class="cc-sub-title">
              <div>
                Data:
                <div class="cc-sub-result">{{ cotacao.atualizado_em }}</div>
              </div>
              <div>
                Cód:
                <div class="cc-sub-result">{{ cotacao.cot_cotacao_id }}</div>
              </div>
            </div>
          </div>
          <div class="cc-footer">
            <span class="btn-ver-cotacao" @click="verCotacao(cotacao.id)">
              Ver Pedido
            </span>
            <div class="row">
              <span class="entregarPedido">Será aprovado até: {{ cotacao.data_pagamento }}
                <i class="fas fa-question-circle question-tool-tips" id="pagamentoUp"></i>
                <b-tooltip target="pagamentoUp">
                  O lojista está conferindo todos os itens desse pedido, assim que aprovado,
                  todos os itens seu pedido vai para pedidos aprovados e segue para separação e envio dos itens.
                </b-tooltip>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import scrollToElement from '../../mixins/scrollToElement';

export default {
  mixins:[scrollToElement],
  name: 'aguardando',
  data() {
    return {
      tokenData: 'Token',
      cotacoes: null
    }
},
  computed: {
    ...mapGetters([
      // Mapeamento de getters
    ]),
    ...mapState({
      // Mapeamento de states
      token: (state) => state.token,
      dadosUsuario: (state) => state.dadosUsuario,
    }),
  },
  mounted(){
    this.scrollToElement();
  },
  created() {
    this.scrollToElement();
    const self = this;

    if (this.checkIsEmpty(this.dadosUsuario)) {
      this.$router.push({ name: 'area-restrita' });
    }

    this.$store.dispatch('emptyCotacoes').then(() => {
      this.$store.dispatch('startLoader');
      setTimeout(() => {
        self.$store
          .dispatch('showCotacoesUsuarioAguardando', this.dadosUsuario.id)
          .then((response) => {
            this.cotacoes = response.data.data;
            setTimeout(() => {
              self.$store.dispatch('endLoader');
            }, 1000);
          })
          .catch(() => {
            setTimeout(() => {
              self.$store
                .dispatch('showCotacoesUsuarioAguardando', this.dadosUsuario.id)
                .then((response) => {
                  this.cotacoes = response.data.data;
                  setTimeout(() => {
                    self.$store.dispatch('endLoader');
                  }, 1000);
                })
                .catch(() => {
                  self.$store.dispatch('endLoader');
                  self.aviso(
                    'Não foi possível carregar os pedidos! Tente novamente em 5 minutos!',
                    'danger'
                  );
                });
            }, 1000);
          });
      }, 1000);
    });
  },
  methods: {
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    verCotacao(value) {
      if (!this.checkIsEmpty(value)) {
        this.$router.push({
          name: 'cliente-cotacao-aguardando-aprovacao',
          params: { id: value },
        });
      }
    },
  },
};
</script>
<style scoped>
.borda {
  color: #000;
}
.entregarPedido {
  width: 100%;
  padding: 5px 0 0 0;
  color: rgb(233, 10, 10);
  font-size: 13px;
  text-align: center;
}
</style>
